import { render, staticRenderFns } from "./IconFontSizeBadge.vue?vue&type=template&id=788197a2"
import script from "./IconFontSizeBadge.vue?vue&type=script&lang=js"
export * from "./IconFontSizeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports